import React, { useState, useEffect } from "react";
import CustomerInformation from "./CustomerInformation";
import ReactDOM from "react-dom";
import { useNavigate, useLocation } from "react-router-dom";
import CampaignService from "../../service/CampaignService";

export default function BookingInformation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { orderNo, salesNo, orderKey } = location.state;

  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const [orderInfo, setOrderInfo] = useState(null);
  const [showLockAlert, setShowLockAlert] = useState(false); //명단 잠금 알림 팝업

  const OrderInfo = async () => {
    if (orderNo === null || salesNo === null || orderKey === null) {
      navigate(`/error`);
      return;
    }

    try {
      const result = await CampaignService.orderInfo(
        orderNo,
        salesNo,
        orderKey
      );

      if (result) {
        setOrderInfo(result);
        // 명단 잠금 여부 확인 후 팝업 표시
        if (result.명단잠금여부 === true) {
          setShowLockAlert(true);
        }
      } else {
        navigate(`/error`);
      }
    } catch (error) {
      navigate(`/error`);
    } finally {
    }
  };

  useEffect(() => {
    const initFetch = async () => {
      await OrderInfo();
    };
    initFetch();
  }, [location]);

  // Effect to toggle body scroll based on drawer state
  useEffect(() => {
    const body = document.body;
    if (drawerOpen) {
      body.style.overflow = "hidden";
    } else {
      body.style.overflow = "";
    }

    // Cleanup function to reset overflow style
    return () => {
      body.style.overflow = "";
    };
  }, [drawerOpen]);

  return (
    <>
      <div className="mx-auto  max-w-[500px] relative" onClick={toggleDrawer}>
        {" "}
        {/* Adjust padding bottom as needed */}
        <img
          alt="Eiffel Tower"
          className="w-full rounded-t-lg"
          src="https://kr.object.iwinv.kr/orgin/1/Place/GettyImages-1185953092.jpg"
          style={{ aspectRatio: "264/500", objectFit: "cover" }}
        />
        {/* Overlay with package details */}
        {/* <div className="absolute top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 flex items-center justify-center p-4 rounded-t-lg">
          <div className="text-white text-center">
            <p className="text-lg">
              [다낭 3박5일
              패키지]다낭/호이안/바나힐+5성호텔+스톤마사지2시간-비엣젯항공
              (VJ879편 / 07시 00분 출발)
            </p>
          </div>
        </div> */}
        <div className="absolute top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 p-4 rounded-t-lg flex flex-col justify-start items-center">
          <div className="text-white text-center mb-auto mt-20">
            <p className="text-xl">{orderInfo?.상품명 || ""}</p>
          </div>
          {/* Other content can go here */}
        </div>
      </div>
      {/* Fixed info at the bottom */}
      <div
        className="fixed bottom-0 left-1/2 transform -translate-x-1/2 max-w-[500px] w-full bg-white p-4 rounded-t-lg shadow-lg "
        onClick={toggleDrawer}
      >
        <div className="flex justify-between">
          <h2 className="text-lg font-bold">예약번호</h2>
          <h2 className="text-lg font-bold"> {orderInfo?.주문번호 || ""}</h2>
        </div>

        <div className="flex justify-between">
          <h2 className="text-sm text-gray-500 font-bold">행사일</h2>
          <h2 className="text-sm  text-gray-500 font-bold">
            {orderInfo?.행사일}
          </h2>
        </div>

        <div className="flex justify-between">
          <h2 className="text-sm text-gray-500 font-bold">성인</h2>
          <h2 className="text-sm  text-gray-500 font-bold">
            {orderInfo?.성인수 || 0}
          </h2>
        </div>

        <div className="flex justify-between">
          <h2 className="text-sm text-gray-500 font-bold">어린이</h2>
          <h2 className="text-sm  text-gray-500 font-bold">
            {orderInfo?.소아수 || 0}
          </h2>
        </div>

        <div className="flex justify-between">
          <h2 className="text-sm text-gray-500 font-bold">영유아</h2>
          <h2 className="text-sm  text-gray-500 font-bold">
            {orderInfo?.유아수 || 0}
          </h2>
        </div>

        {/* Divider line */}
        <hr className="my-2" />

        {/* 여행객 정보 입력 안내사항 */}
        <div className="bg-gray-50 p-2 mb-2 rounded">
          <div
            className="text-gray-600 space-y-0.5"
            style={{ fontSize: "12px" }}
          >
            <p
              style={{
                fontSize: "12px",
                margin: "0",
                textIndent: "-8px",
                paddingLeft: "8px",
              }}
            >
              • 여권 신규 발급/재발급의 경우 발급요청한 영문이름과 동일하게
              적어주세요.
            </p>
            <p
              style={{
                fontSize: "12px",
                margin: "0",
                textIndent: "-8px",
                paddingLeft: "8px",
              }}
            >
              • 발권 이후에는 영문 철자 수정이 불가 하며, 환불 또한 불가 할 수
              있습니다.
            </p>
            <p
              style={{
                fontSize: "12px",
                margin: "0",
                textIndent: "-8px",
                paddingLeft: "8px",
              }}
            >
              • 탑승객 정보 나이는 출발일 기준입니다.
            </p>
            <p
              style={{
                fontSize: "12px",
                margin: "0",
                textIndent: "-8px",
                paddingLeft: "8px",
              }}
            >
              • 유아(24개월 미만) 탑승객은 성인 1인당 1인만 등록 가능 합니다.
            </p>
            <p
              style={{
                fontSize: "12px",
                margin: "0",
                textIndent: "-8px",
                paddingLeft: "8px",
              }}
            >
              • 발권 이후 정보 수정이 필요한 경우 별도로 문의 바라며, 수수료가
              발생 될 수 있습니다.
            </p>
          </div>
        </div>

        {/* Customer info entry with right arrow for navigation */}
        <div
          className="flex justify-between items-center cursor-pointer "
          onClick={toggleDrawer}
        >
          <div className="text-sm text-slate-750 font-semibold ">
            여행객 정보
          </div>
          <svg
            className="h-6 w-6 text-slate-750"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
      </div>

      {/* Drawer Component */}
      {drawerOpen &&
        ReactDOM.createPortal(
          <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex justify-end">
            <div className="h-full w-full md:w-full  bg-white overflow-y-auto">
              <CustomerInformation
                toggleDrawerProp={toggleDrawer}
                orderNo={orderNo}
                salesNo={salesNo}
                orderKey={orderKey}
              />
            </div>
          </div>,
          document.body
        )}

      {/* 명단 잠금 알림 팝업 */}
      {showLockAlert &&
        ReactDOM.createPortal(
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg w-full max-w-sm mx-auto">
              {/* 팝업 헤더 */}
              <div className="p-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">알림</h3>
              </div>

              {/* 팝업 내용 */}
              <div className="p-4">
                <p className="text-sm text-gray-600 leading-relaxed">
                  명단입력이 완료되었습니다. 명단수정을 할 수 없습니다
                </p>
              </div>

              {/* 팝업 버튼 */}
              <div className="p-4 border-t border-gray-200">
                <button
                  onClick={() => setShowLockAlert(false)}
                  className="w-full py-2 px-4 text-sm font-medium text-white bg-cyan-500 rounded-lg hover:bg-cyan-600 transition-colors"
                >
                  확인
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
}
